'use client'

import type { MenuItem, MenuSeparator } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

import { MenuActionId } from '../enums'

export const BASE_PROJECT_ITEMS: (MenuItem | MenuSeparator)[] = [
  {
    type: 'item',
    icon: Icon.SettingsRegular,
    active: true,
    groups: [],
    label: 'Settings',
    id: MenuActionId.PROJECT_SETTINGS,
    size: 'xs',
  },
  {
    type: 'item',
    icon: Icon.PeopleRegular,
    active: true,
    groups: [],
    label: 'Project members',
    id: MenuActionId.PROJECT_MEMBERS,
    size: 'xs',
  },
  {
    type: 'item',
    icon: Icon.PeopleAddRegular,
    active: true,
    groups: [],
    label: 'Invite people',
    id: MenuActionId.INVITE_PEOPLE,
    size: 'xs',
  },
  {
    id: 'sep-1',
    type: 'separator',
  },
]
